<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
    persistent
  >
    <v-card>
      <v-toolbar dark :color="options.color" dense flat>
        <v-toolbar-title class="white--text">{{ title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pa-4"
        >カードリーダーにカードをかざしてください。</v-card-text
      >
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click.native="cancel">キャンセル</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    idmMessage: "",
    dialog: false,
    resolve: null,
    reject: null,
    message: null,
    title: null,
    seqNumber: 0,
    cancelFlg: false,
    options: {
      color: "primary",
      width: 350,
      zIndex: 200,
    },
    deviceFilters: [
      {
        vendorId: 0x054c,
        productId: 0x06c1,
        deviceModel: 380,
      },
      {
        vendorId: 0x054c,
        productId: 0x06c3,
        deviceModel: 380,
      },
      {
        vendorId: 0x054c,
        productId: 0x0dc8,
        deviceModel: 300,
      },
      {
        vendorId: 0x054c,
        productId: 0x0dc9,
        deviceModel: 300,
      },
    ],
    deviceModelList: {
      0x06c1: 380,
      0x06c3: 380,
      0x0dc8: 300,
      0x0dc9: 300,
    },
    deviceModel: "",
    deviceEp: {
      in: 0,
      out: 0,
    },
  }),
  props: {
    setCardNo: {
      type: Function,
      required: false,
    },
  },
  methods: {
    //ポップアップを表示
    open(title, message, options) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    //ICカード読み取り処理開始
    clickIcon() {
      this.start();
    },

    //ポップアップを閉じる
    cancel() {
      this.resolve(false);
      this.dialog = false;
      this.cancelFlg = true;
    },

    dec2HexString(n) {
      return this.padding_zero((n * 1).toString(16).toUpperCase(), 2);
    },
    padding_zero(num, p) {
      return ("0".repeat(p * 1) + num).slice(-(p * 1));
    },
    async sleep(msec) {
      return new Promise((resolve) => setTimeout(resolve, msec));
    },
    async send(device, data) {
      let uint8a = new Uint8Array(data);
      // console.log(">>>>>>>>>>");
      await device.transferOut(this.deviceEp.out, uint8a);
      //await device.transferOut(2, uint8a);
      await this.sleep(10);
    },

    async receive(device, len) {
      // console.log("<<<<<<<<<<" + len);
      //let data = await device.transferIn(1, len);
      let data = await device.transferIn(this.deviceEp.in, len);
      await this.sleep(10);
      let arr = [];
      let arr_str = [];
      for (let i = data.data.byteOffset; i < data.data.byteLength; i++) {
        arr.push(data.data.getUint8(i));
        arr_str.push(this.dec2HexString(data.data.getUint8(i)));
      }
      // console.log(arr_str);
      return arr;
    },

    async proc() {
      if (this.$getCardType() == "Felica") {
        this.start();
      } else {
        // console.log("NONE")
      }
    },
    async start() {
      this.idmMessage = "";
      let device;
      let i = 0;
      try {
        // ペアリング済みの対応デバイスが1つだったら、自動選択にする
        let pearedDevices = await navigator.usb.getDevices();
        pearedDevices = pearedDevices.filter((d) =>
          this.deviceFilters.map((p) => p.productId).includes(d.productId)
        );
        // 自動選択 or 選択画面
        device =
          pearedDevices.length == 1
            ? pearedDevices[0]
            : await navigator.usb.requestDevice({
                filters: this.deviceFilters,
              });
        this.deviceModel = this.deviceModelList[device.productId];
        await device.open();
      } catch (e) {
        // console.log(e);
        throw e;
      }
      try {
        await device.selectConfiguration(1);
        // await device.claimInterface(0);
        const interfaceNumId = device.configuration.interfaces.filter(
          (v) => v.alternate.interfaceClass == 255
        )[0];
        await device.claimInterface(interfaceNumId.interfaceNumber);
        this.deviceEp = {
          in: interfaceNumId.alternate.endpoints.filter(
            (e) => e.direction == "in"
          )[0].endpointNumber,
          out: interfaceNumId.alternate.endpoints.filter(
            (e) => e.direction == "out"
          )[0].endpointNumber,
        };
        this.open();
        do {
          this.deviceModel == 300
            ? await this.session300(device)
            : await this.session380(device);
          // await this.session(device);
          await this.sleep(500);
          // console.log("取得した結果確認：cancelFlh" + this.cancelFlg);
          //idm取得 or キャンセル押下でセッション終了
          if (this.cancelFlg == true) {
            this.cancel(); //モーダルウィンドウを閉じる
            this.cancelFlg = false; //キャンセルフラグを戻す
            break;
          } else if (this.idmMessage != "") {
            this.setCardNo(this.idmMessage);
            // console.log(this.idmMessage)
            // this.$emit("setCardNo", this.idmMessage)
            this.cancel(); //モーダルウィンドウを閉じる
            this.cancelFlg = false; //キャンセルフラグを戻す
            break;
          }
        } while (i == 0);
      } catch (e) {
        // console.log(e);
        try {
          this.device.close();
        } catch (e) {
          //   console.log(e);
        }
        throw e;
      }
    },

    async session300(device) {
      const len = 50;
      // firmware version
      await this.send300(device, [0xff, 0x56, 0x00, 0x00]);
      // ['83', '14', '0', '0', '0', '0', '0', '0', '0', '0', '0', '0', '1', '0', '1', '0', 'ff', 'ff', '4', '1', 'ff', 'ff', '1', '0', 'ff', 'ff', '0', '0', '90', '0']
      await this.receive(device, len);

      // endtransparent
      await this.send300(
        device,
        [0xff, 0x50, 0x00, 0x00, 0x02, 0x82, 0x00, 0x00]
      );
      // ['83', '07', '00', '00', '00', '00', '01', '02', '00', '00', 'C0', '03', '00', '90', '00', '90', '00']
      await this.receive(device, len);

      // startransparent
      await this.send300(
        device,
        [0xff, 0x50, 0x00, 0x00, 0x02, 0x81, 0x00, 0x00]
      );
      // ['83', '07', '00', '00', '00', '00', '01', '02', '00', '00', 'C0', '03', '00', '90', '00', '90', '00']
      await this.receive(device, len);

      // rf off
      await this.send300(
        device,
        [0xff, 0x50, 0x00, 0x00, 0x02, 0x83, 0x00, 0x00]
      );
      // ['83', '07', '00', '00', '00', '00', '01', '02', '00', '00', 'C0', '03', '00', '90', '00', '90', '00']
      await this.receive(device, len);

      // rf on
      await this.send300(
        device,
        [0xff, 0x50, 0x00, 0x00, 0x02, 0x84, 0x00, 0x00]
      );
      // ['83', '07', '00', '00', '00', '00', '01', '02', '00', '00', 'C0', '03', '00', '90', '00', '90', '00']
      await this.receive(device, len);

      // SwitchProtocolTypeF
      await this.send300(
        device,
        [0xff, 0x50, 0x00, 0x02, 0x04, 0x8f, 0x02, 0x03, 0x00, 0x00]
      );
      // ['C0', '03', '00', '90', '00', '90', '00']
      await this.receive(device, len);

      // ferica poling
      await this.send300(
        device,
        [
          0xff, 0x50, 0x00, 0x01, 0x00, 0x00, 0x11, 0x5f, 0x46, 0x04, 0xa0,
          0x86, 0x01, 0x00, 0x95, 0x82, 0x00, 0x06, 0x06, 0x00, 0xff, 0xff,
          0x01, 0x00, 0x00, 0x00, 0x00,
        ]
      );
      // poling検出時 *がIDm
      // ['83', '24', '00', '00', '00', '00', '06', '02', '00', '00']
      // ['C0', '03', '00', '90', '00', '92', '01', '00', '96', '02', '00', '00', '97', '14', '14', '01', '**', '**', '**', '**', '**', '**', '**', '**', '05', '31', '43', '45', '46', '82', 'B7', 'FF', '00', '03', '90', '00']
      // poling未検出時
      // ['83', '07', '00', '00', '00', '00', '98', '02', '00', '00']
      // ['C0', '03', '02', '64', '01', '90', '00']
      const poling_res_f = await this.receive(device, len);
      if (poling_res_f.length == 46) {
        const idm = poling_res_f
          .slice(26, 34)
          .map((v) => this.dec2HexString(v));
        this.idmMessage = idm.join("");
        // console.log(this.idmMessage)
        return;
      }
      // SwitchProtocolTypeA
      await this.send300(
        device,
        [0xff, 0x50, 0x00, 0x02, 0x04, 0x8f, 0x02, 0x00, 0x03, 0x00]
      );
      // ['C0', '03', '00', '90', '00', '90', '00']
      await this.receive(device, len);

      // GET Card UID
      await this.send300(device, [0xff, 0xca, 0x00, 0x00]);

      // poling検出時 *がIDm
      // ['83', '06', '00', '00', '00', '00', '04', '02', '00', '00']
      // ['**', '**', '**', '**', '90', '00']

      // ['83', '07', '00', '00', '00', '00', '41', '02', '00', '00']
      // ['C0', '03', '01', '64', '01', '90', '00']
      // or ['6F', '00']
      const poling_res_a = await this.receive(device, len);
      if (poling_res_a.length == 16) {
        const id = poling_res_a.slice(10, 14).map((v) => this.dec2HexString(v));
        this.idmMessage = id.join("");
        // console.log(this.idmMessage)
        return;
      }
    },
    async send300(device, data) {
      let argData = new Uint8Array(data);
      const dataLen = argData.length;
      const SLOTNUMBER = 0x00;
      let retVal = new Uint8Array(10 + dataLen);

      retVal[0] = 0x6b; // ヘッダー作成
      retVal[1] = 255 & dataLen; // length をリトルエンディアン
      retVal[2] = (dataLen >> 8) & 255;
      retVal[3] = (dataLen >> 16) & 255;
      retVal[4] = (dataLen >> 24) & 255;
      retVal[5] = SLOTNUMBER; // タイムスロット番号
      retVal[6] = ++this.seqNumber; // 認識番号

      0 != dataLen && retVal.set(argData, 10); // コマンド追加
      await device.transferOut(this.deviceEp.out, retVal);
      await this.sleep(50);
    },
  },
};
</script>
<style></style>
